module.exports = __webpack_public_path__ + "static/media/tourism.71d51feb.webp";